/**
 * Banner 8 — Background-image hero with title + description + a grid of info
 * cards (icon / title / description). Cards are separated by dividers
 * (vertical on desktop after every second card, horizontal between every card
 * on mobile). All colors, background images, and the cards list are
 * admin-driven.
 */

export const BANNER_8_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    priority: 1,
    status: true,
    metaImg: "",
    altImg: "",
    metaTitle: "Industry-led curriculum",
    metaDescription:
      "Designed and taught by senior practitioners shipping production AI today.",
  },

  METADATA_TITLES: {
    metadata: "Info Cards",
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title (wrap highlight in { } e.g. Key {skills})",
      value: "Key {skills} you'll build",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Key {skills} you'll build",
      required: false,
      defaultValue: "Key {skills} you'll build",
      rows: 2,
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Short paragraph below the title",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "image",
      label: "Desktop background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile background image (falls back to desktop)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "image_alt",
      label: "Background image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Section background color (fallback if no image)",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "title_color",
      label: "Title color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_highlight_color",
      label: "Title highlight color (for {...} text)",
      value: "#FFD700",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFD700",
      required: false,
      defaultValue: "#FFD700",
    },
    {
      fieldName: "description_color",
      label: "Description color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_title_color",
      label: "Card title color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_description_color",
      label: "Card description color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "divider_color",
      label: "Divider color (line between cards)",
      value: "#F8FAFC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#F8FAFC",
      required: false,
      defaultValue: "#F8FAFC",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (1, 2, 3…)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide this card",
      defaultValue: true,
    },
    {
      header: "Icon",
      fieldName: "metaImg",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
    },
    {
      header: "Icon alt text",
      fieldName: "altImg",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the icon",
    },
    {
      header: "Title",
      fieldName: "metaTitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Card title",
    },
    {
      header: "Description",
      fieldName: "metaDescription",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Card description",
      rows: 3,
    },
  ],
};
